import Model from './BaseModel';

export default class TrackFees extends Model {
	resourceName() {
		return 'track_fees';
	}

	fields() {
		return ['fees', 'race_type'];
	}

	// override the base update for our request specific URL
	update(trackId, data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/tracks/${trackId}/fees`,
			method: 'POST',
			data
		});
	}
}
